import { render } from "./password_reset_form.vue?vue&type=template&id=67e37e5a"
import script from "./password_reset_form.vue?vue&type=script&lang=js"
export * from "./password_reset_form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__